




















import { Vue } from 'vue-property-decorator'
import ScreenTile from '../components/ScreenTile.vue'
import CategoryTile from '../components/CategoryTile.vue'

interface IReport {
  id: string
  name: string
  description: string
  imageUrl: string
  favorite: boolean
}

interface IReportGroup {
  name: string
  reports: IReport[]
}

export default Vue.extend({
  components: { ScreenTile, CategoryTile },
  data: function () {
    return {
      loading: true,
      reports: [] as IReportGroup[],
    }
  },
  methods: {
    getReports: function (reports: IReport[]) {
      return reports.map((x) => ({
        title: x.name,
        id: x.id,
        imageUrl: x.imageUrl,
        favorite: x.favorite,
        description: x.description,
      }))
    },
    loadReport: async function (report: {
      id: string
      title: string
      favorite: boolean
      description: string
    }) {
      this.$router.push(
        `/reports/${report.id}/${report.description}/${report.favorite}`
      )
    },
  },
  mounted: async function () {
    const reports = (await (await fetch('/api/reports')).json()) as IReport[]
    const categories = Array.from(
      new Set(reports.map((x) => x.name.split(' - ')[0]))
    )

    for (const category of categories) {
      const reportGroup = {
        name: category,
        reports: reports
          .filter((x) => x.name.startsWith(category))
          .map((x) => ({
            id: x.id,
            description: x.name,
            name: x.name.split(' - ')[1],
            imageUrl: `icons/reports/${x.name}.svg`,
            favorite: x.favorite,
          })),
      }
      this.reports.push(reportGroup)
    }
    this.loading = false
  },
})
